<p>unregister-sw works!</p>
